import * as React from 'react'
import styled from 'styled-components'

import type { StyleProps } from './spinner'

/* eslint-disable indent */
const SpinnerStyles = (
  component: React.ComponentType<any>,
  attrs: Function,
): React.ComponentType<any> => {
  const styledComponent = styled(component)

  return styledComponent.attrs(attrs)`
    animation: spin 2s linear infinite;

    ${({ kind }: StyleProps) => {
      const size = kind === 'large' ? '1.5rem' : (kind === 'medium' && '1.375rem') || '.75rem'
      return ['width', 'height'].map(attribute => `${attribute}: ${size}`).join(';')
    }};
  `
}

export default SpinnerStyles
